"use client";
import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import SubmissionSuccessCard from "./SubmissionSuccessCard";
import { RotateCw } from "lucide-react";

// ---------------------------------------------------------------------------
// Main Form Component
// ---------------------------------------------------------------------------
export default function RefreshForm() {
  const initialFormState = {
    fullName: "",
    schoolName: "",
    location: "",
    webLink: "", 
    specialRequest:""
  };

  const [formData, setFormData] = useState(initialFormState);
  const [showCustomModal, setShowCustomModal] = useState(false);

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [submissionResult, setSubmissionResult] = useState(null);
  
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleResetForm = () => {
    setFormData(initialFormState);
    setSubmissionResult(null);
    setIsSubmitted(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let cleanedData = { ...formData };
    if (cleanedData.webLink && !cleanedData.webLink.startsWith("http")) {
      cleanedData.webLink = `https://${cleanedData.webLink}`;
    }

    try {
      const response = await fetch("/api/refresh", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(cleanedData),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Server Error:", errorText);
        alert("Failed to submit form. Please check requirements.");
        return;
      }

      const result = await response.json();

      if (result.success) {
        setSubmissionResult(result);
        setIsSubmitted(true);
      } else {
        alert(result.error || "An error occurred during submission.");
      }
    } catch (error) {
      console.error("Submission error:", error);
    }
  };

  if (isSubmitted) {
    return (
      <div className="w-full flex justify-center py-20 px-4 bg-orange-50/50">
        <SubmissionSuccessCard
          responseData={submissionResult}
          onResetForm={handleResetForm}
        />
      </div>
    );
  }

  return (
    <>

      {showCustomModal && mounted && createPortal(customModalMarkup, document.body)}

      <div className="w-full flex justify-center py-20 px-4 bg-orange-50/50">
        <form onSubmit={handleSubmit} className="w-[480px]">
          <div className="bg-white p-10 pb-12 rounded-[2.5rem] shadow-2xl border-t-8 border-sky-400 relative rotate-1 hover:rotate-0 transition-transform duration-500 ease-in-out">
            <div className="absolute -top-6 -right-6 bg-white rounded-full p-3 shadow-lg border border-slate-100">
            <RotateCw
                className="w-10 h-10 text-sky-500 stroke-[2.75]"
            />
            </div>

            <h2 className="text-3xl font-bold text-sky-500 mb-10 flex items-center gap-2">
              Refresh my list
            </h2>
            <p className="text-sm text-slate-400 mb-8">
              Wishlist already posted, but information outdated? Request a refresh.
            </p>
            <div className="space-y-6">
              <div className="grid grid-cols-1 gap-4">
                <input
                  className="p-4 rounded-2xl border-2 border-slate-100 focus:border-amber-400 outline-none transition-all placeholder:text-slate-300 text-sm bg-slate-50"
                  name="fullName" placeholder="Teacher Name"
                  value={formData.fullName} onChange={handleChange} required
                />
              </div>

              <div className="space-y-4">
                <input
                  className="w-full p-4 rounded-2xl border-2 border-slate-100 focus:border-amber-400 outline-none transition-all placeholder:text-slate-300 text-sm bg-slate-50"
                  name="schoolName" placeholder="School Name"
                  value={formData.schoolName} onChange={handleChange} required
                />
              </div>
                <div className="space-y-4">
                <input
                  className="w-full p-4 rounded-2xl border-2 border-slate-100 focus:border-amber-400 outline-none transition-all placeholder:text-slate-300 text-sm bg-slate-50"
                  name="location" placeholder="School Location: City, State"
                  value={formData.location} onChange={handleChange} required
                />
              </div>

              <div className="grid grid-cols-1 gap-4">
                <input
                  className="col-span-3 p-4 rounded-2xl border-2 border-slate-100 focus:border-amber-400 outline-none transition-all placeholder:text-slate-300 text-sm bg-slate-50"
                  name="webLink" type="text" placeholder="Wishlist Link 🔗"
                  value={formData.webLink} onChange={handleChange}
                />
              </div>
                <div className="grid grid-cols-1 gap-4">
                <textarea
                    className="col-span-3 h-32 p-4 rounded-2xl border-2 border-slate-100 focus:border-amber-400 outline-none transition-all placeholder:text-slate-300 text-sm bg-slate-50 resize-none overflow-y-auto"
                    name="specialRequest"
                    placeholder="Note or special request"
                    value={formData.specialRequest}
                    onChange={handleChange}
                />
                </div>

              <div className="text-center pt-4">
                <button
                  type="submit"
                  className={`w-full font-bold py-5 rounded-2xl transition-all text-xl 
                    ${"bg-amber-400 hover:bg-amber-500 text-amber-950 shadow-[0_5px_0_0_#ca8a04] active:shadow-none active:translate-y-1"
                    }`}
                >
                  Refresh my list
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}